/* unplugin-vue-components disabled */import { render } from "./FlowingLight.vue?vue&type=template&id=f49a63e0&scoped=true"
const script = {}

import "./FlowingLight.vue?vue&type=style&index=0&id=f49a63e0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f49a63e0"]])

export default __exports__